import React from 'react';
import proptypes from 'prop-types';
const { bool } = proptypes;
import { FulfillmentPlaceholderStencil } from './FulfillmentPlaceholderStencil';

const FulfillmentPlaceholder = ({ isMajorAppliances = false, isBuyBoxLite = false }) => {

  return (
    <FulfillmentPlaceholderStencil
      isMajorAppliances={isMajorAppliances}
      isBuyBoxLite={isBuyBoxLite}
    />
  );

};

FulfillmentPlaceholder.propTypes = {
  isMajorAppliances: bool,
  isBuyBoxLite: bool
};

export { FulfillmentPlaceholder };
